export default __webpack_public_path__ + "static/media/prev-aircare.0c6125b0.jpg";